<template>
  <div class="Help">
    <h1>販売お問合せ窓口</h1>
    <div class="section">
      <h2>お問合せの前に</h2>
      <div class="description">以下の内容で解決できるかご確認ください。</div>
      <div class="buttonsWrapper">
        <div class="buttons">
          <NuxtLink to="/guides#terms" class="half-width" target="_blank">
            <Button text="利用条件" mode="secondary" width="100%" />
          </NuxtLink>
          <NuxtLink to="/guides#delivery" class="half-width" target="_blank">
            <Button text="送料・配送方法" mode="secondary" width="100%" />
          </NuxtLink>
        </div>
        <div class="buttons">
          <NuxtLink to="/guides#payment" class="half-width" target="_blank">
            <Button text="支払方法" mode="secondary" width="100%" />
          </NuxtLink>
          <NuxtLink to="/guides#date" class="half-width" target="_blank">
            <Button text="発送・到着日" mode="secondary" width="100%" />
          </NuxtLink>
        </div>
        <div class="buttons">
          <NuxtLink to="/guides#cancel" class="half-width" target="_blank">
            <Button text="注文キャンセル" mode="secondary" width="100%" />
          </NuxtLink>
          <NuxtLink to="/guides#returns" class="half-width" target="_blank">
            <Button text="返品・交換" mode="secondary" width="100%" />
          </NuxtLink>
        </div>
        <div class="buttons">
          <NuxtLink to="/pokemon/conditions" class="half-width" target="_blank">
            <Button text="カードの状態" mode="secondary" width="100%" />
          </NuxtLink>
          <NuxtLink to="/guides#migration" class="half-width" target="_blank">
            <Button text="会員引継ぎ" mode="secondary" width="100%" />
          </NuxtLink>
        </div>
      </div>
    </div>
    <div class="border" />
    <div class="section">
      <h2>フォームによるお問合せ</h2>
      <div class="description">
        月曜〜土曜の17:00までにいただいたお問合せにつきましては当日中にメールにてご返信します。
      </div>
      <NuxtLink :to="contactLink">
        <Button text="お問合せフォーム" width="100%" />
      </NuxtLink>
    </div>
  </div>
</template>

<script lang="ts">
import { defineNuxtComponent } from "#app";
import { Button } from "@ka-nabellinc/ka-nabell-ui";
import { useProfileWeb } from '@/composables/useProfileWeb'

export default defineNuxtComponent({
  components: {
    Button,
  },
  setup() {
    const { contactLink } = useProfileWeb()
    return {
      contactLink,
    };
  },
});
</script>

<style scoped>
.Help {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-top: 8px;
}

.section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.description {
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0.14px;
}

.buttonsWrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.buttons {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.border {
  height: 1px;
  background: #ebebeb;
}

.half-width {
  flex: 1;
}

.empty {
  min-width: 143px;
}
</style>
